// eslint-disable-next-line no-restricted-imports -- this avoids a circular dependency. Importing this type should be fine.
import {type GenerateUrlArgs} from "@khanacademy/perseus";
import {staticUrl, toAbsoluteUrl} from "@khan/urls";

/**
 * A default implementation of the PerseusDependenciesV2.generateUrl dependency
 * function. It takes a URL or partial url and may modify it to return
 * the full URL. This may be used to request a resource from a different
 * app to where the widget is rendered, like when embedding a video
 * cross-domain.
 */
export const generateUrl = ({url, context}: GenerateUrlArgs): string => {
    switch (context) {
        case "image_loader:image_url":
            return staticUrl(url);
        case "video:video_url":
            return toAbsoluteUrl(url);
        case "python_program:program_url":
            return toAbsoluteUrl(url);
        default:
            return url;
    }
};
